import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import ChatWidget from "./ChatWidget";
import { useSettings } from "@/context/SettingsContext";

function injectRaw(html, container) {
  container.innerHTML = "";
  if (!html) return;
  const tpl = document.createElement("template");
  tpl.innerHTML = html;
  Array.from(tpl.content.childNodes).forEach((node) => {
    if (node.tagName === "SCRIPT") {
      const s = document.createElement("script");
      Array.from(node.attributes).forEach((a) => s.setAttribute(a.name, a.value));
      s.textContent = node.textContent;
      container.appendChild(s);
    } else {
      container.appendChild(node.cloneNode(true));
    }
  });
}

export default function StoreLayout() {
  const { settings } = useSettings();

  useEffect(() => {
    const seo = settings?.seo;
    if (!seo) return;
    if (seo.meta_title) document.title = seo.meta_title;
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
    m.content = seo.meta_description || "";
    let head = document.getElementById("sv-head-inject");
    if (!head) { head = document.createElement("div"); head.id = "sv-head-inject"; document.head.appendChild(head); }
    injectRaw(seo.head_scripts, head);
    let body = document.getElementById("sv-body-inject");
    if (!body) { body = document.createElement("div"); body.id = "sv-body-inject"; document.body.appendChild(body); }
    injectRaw(seo.body_scripts, body);
  }, [settings]);

  return (
    <div className="min-h-screen flex flex-col bg-linen">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <CartDrawer />
      <ChatWidget />
    </div>
  );
}
